import React from 'react'
import PropTypes from 'prop-types'
import { ApolloProvider } from '@apollo/client'

import { useApollo } from '@/graphql/apolloClient'

const withApollo = WrappedComponent => {
  const Wrapper = props => {
    const { pageProps } = props
    const apolloClient = useApollo(pageProps)

    return (
      <ApolloProvider client={apolloClient}>
        <WrappedComponent {...props} />
      </ApolloProvider>
    )
  }

  Wrapper.propTypes = {
    pageProps: PropTypes.object.isRequired,
  }

  if (WrappedComponent.getInitialProps) {
    Wrapper.getInitialProps = WrappedComponent.getInitialProps
  }

  return Wrapper
}

export default withApollo
